import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MarkerService } from '../../../../services/marker.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-captain-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './captain-banner.component.html',
  styleUrl: './captain-banner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaptainBannerComponent {
  $captainMarker!: Observable<any>;

  captainText: string = 'Captain';
  seaTowText: string = 'Sea Tow';

  constructor(private markerService: MarkerService) {
    this.$captainMarker = this.markerService.$captainMarker;
  }
}
